export default __webpack_public_path__ + "static/media/car-icon-blue.defea45b.svg";